<template>
  <footer class="bg-paroma-2">
    <div
      class="px-4 py-2 mx-auto max-w-7xl sm:px-6 lg:pt-12 lg:px-8"
      v-if="isAuthenticated == 'Undefined'"
    >
      <h2 class="sr-only">Footer</h2>
    </div>
    <minimal-footer
      class="bg-paroma-2"
      :showBasicLinks="false"
      v-if="isAuthenticated == 'Undefined'"
    />
    <minimal-footer class="w-full max-h-50 border-t" v-else />
  </footer>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import MinimalFooter from './MinimalFooter.vue';
import store from '@/store/store';

export default defineComponent({
  name: 'NavigationFooter',
  components: { MinimalFooter },
  setup() {
    const registerUrl = process.env.VUE_APP_REGISTERPATH;
    const paromaMedOfficialUrl = process.env.VUE_APP_PAROME_MED_OFFICIAL_URL;
    const loginUrl = process.env.VUE_APP_LOGINPATH;
    const paromaMedAppContactUsUrl = paromaMedOfficialUrl + '/contact';
    const isRegistrationOpen = process.env.VUE_APP_REGISTRATION_OPEN;
    const isAuthenticated = computed(() => store.getters.fullName);

    return {
      paromaMedOfficialUrl,
      loginUrl,
      registerUrl,
      paromaMedAppContactUsUrl,
      isRegistrationOpen,
      isAuthenticated,
    };
  },
});
</script>

<style scoped>
.color-none {
  color: #333;
}
.color-none:hover {
  color: #1c5d9a;
}
</style>
